module.exports = __webpack_public_path__ + "static/marker-hover-68a3c506825b38dc99271500beb8cbf7.png";